import { RequestedFeature } from "@vixi/types";

export type EndpointsDict<
  k extends string = string,
  v extends string | ((...args: any[]) => string) = string | ((...args: any[]) => string),
> = Record<k, v>;

export const endpoints = {
  // CourseMaker
  uploadEbook: "CourseMaker",
  uploadEbookAsync: "CourseMaker/async",
  getCourseJobs: "CourseMaker/jobs",
  getCourseJobStatus: (jobId: string) => `CourseMaker/jobs/${jobId}` as const,
  getCourseJobResult: (jobId: string) => `CourseMaker/jobs/${jobId}/result` as const,
  saveCourse: "CourseMaker/SaveCourse",
  editCourse: "CourseMaker/EditCourse",
  editCourseBase: "CourseMaker/EditBasicCourse",
  getAllCourses: "CourseMaker/all",
  getCourse: "CourseMaker/GetCourseById",
  getCourseBase: "CourseMaker/GetCourseBasicById",

  // Avatars
  createAvatar: "Avatars/openAi",
  saveAvatar: "CourseMaker/SaveCharacter",
  getAvatars: "CourseMaker/characters/all",

  // Categories
  getCategories: "Categories/",
  getSubcategory: "Categories/subcategories",

  // Marketing Kit
  generateInstagramStory: "/MarketingKits/instagram/story",
  generateInstagramPost: "/MarketingKits/instagram/post",
  generateLinkedInPost: "/MarketingKits/linkedin/post",

  // Features
  getSuggestedFeatures: "Features",
  requestFeature: "Features",
  getMyFeatures: "Features/me",
  getFeatureById: (id: RequestedFeature["id"]) => `Features/${id}` as const,
  deleteFeature: (id: RequestedFeature["id"]) => `Features/${id}` as const,
  upvoteFeature: (id: RequestedFeature["id"]) => `Features/upvote/${id}` as const,
  downvoteFeature: (id: RequestedFeature["id"]) => `Features/downvote/${id}` as const,

  // Payments
  getPaymentInfo: "Payments/information",
  subscriptionCheckout: "Payments/subscription/checkout",
  updateSubscription: "Payments/subscription",
  cancelSubscription: "Payments",

  // User endpoints
  login: "Users/educator/login",
  register: "Users/register",
  confirmEmail: "Users/confirmEmail",
  resendConfirmationEmail: "Users/resendConfirmationEmail",
  twoFactorAuthentication: "Users/manage/2fa",
  refresh: "Users/refresh",
  userInfo: "Users/getUserInfo",
} as const satisfies EndpointsDict;

export type CoursemakerEndpoints = typeof endpoints;

export type EndpointValues<
  Endpoints extends Record<string, string | ((...args: any[]) => string)>,
> = {
  [K in keyof Endpoints]: Endpoints[K] extends (...args: any[]) => string
    ? ReturnType<Endpoints[K]>
    : Endpoints[K];
}[keyof Endpoints];

export type CoursemakerEndpointVal = EndpointValues<CoursemakerEndpoints>;
